/**
 * Removes Bootstrap backdrops that outlived the modal they belonged to, along with the body
 * locks that come with them.
 *
 * A modal that unmounts while it is still open never runs its exit transition, which can
 * leave its backdrop in the document. Those leftovers are not only cosmetic: each one is a
 * <div> child of <body>, it keeps swallowing clicks even while it is transparent, and it
 * survives until the page is reloaded.
 *
 * Bails while any modal element is still in the document. A modal that is transitioning in
 * does not have the `show` class yet, so `.modal.show` is not a safe thing to test for.
 */
export const cleanupOrphanedModalArtifacts = (): void => {
  if (typeof document === "undefined" || document.querySelector(".modal")) {
    return;
  }

  document.querySelectorAll(".modal-backdrop").forEach(backdrop => {
    backdrop.remove();
  });

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
};
